import { z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';
import { EditorProjectItemSchema } from '$/services/usecases/projects/mapper/editorProject';
import {
  InspirationProjectSchema,
  LegacyInspirationProjectSchema,
} from '$/services/usecases/projects/mapper/inspirationProjects';

export const ProjectOverviewItemSchema = z.pipe(
  z.discriminatedUnion('type', [
    EditorProjectItemSchema,
    InspirationProjectSchema,
    LegacyInspirationProjectSchema,
  ]),
  z.transform((data) => ({
    id: data.id,
    name: data.projectName,
    isPublic: data.isPublic,
    thumbnailUrl: data.projectThumbnail,
    type: data.type,
    parentId: data.parentId,
    schoolClassId: data.schoolClassId,
    schoolClassIds: data.schoolClassIds,
  })),
);

export type ProjectOverviewItem = z.infer<typeof ProjectOverviewItemSchema>;

export const GetProjectOverviewResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.array(ProjectOverviewItemSchema),
});
